import GSAP from 'gsap';

export default class Switch {
    constructor() {
        this.switch = {
            btnToggler: document.getElementById('btn-switch'),
            subscription: document.getElementById('subscription-switch'),
            goodwill: document.getElementById('goodwill-switch'),
        }
    }

    init() {
        this.toggle();
        
    }

    toggle = () => {
        this.switch.btnToggler.addEventListener('click', () => {
            this.switch.subscription.classList.toggle('d-none');
            this.switch.goodwill.classList.toggle('d-none');
        });
    }
}
